<script lang="ts">
    import { StatoTempoEvento } from "./Evento";
    export let stato: StatoTempoEvento = StatoTempoEvento.PASSATO;
</script>

{#if stato == StatoTempoEvento.PASSATO}
<span class="cerchio cerchio_grigio"></span>
{:else if stato == StatoTempoEvento.FUTURO}
<span class="cerchio cerchio_giallo"></span>
{:else}
<span class="cerchio cerchio_verde"></span>
{/if}